<template>
  <CRow class="bg-white d-flex justify-content-between rounded-lg shadow-sm">
    <CCol xs="8" sm="6" md="6" class="d-flex flex-column justify-content-between p-5">
      <h2>{{ title }}</h2>
      <div class="mt-3">
        {{ description }}
      </div>
      <CButton @click="emit('click-button-needSomething')" class="mt-4 rounded py-3 px-5 font-weight-normal align-self-start" color="primary">{{
        textButton
      }}</CButton>
    </CCol>
    <CCol xs="4" sm="6" md="6" class="d-flex justify-content-end" style="background-image: pathImage">
      <img :src="pathImage" class="needImg" />
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'NeedSomething',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    textButton: {
      type: String,
      default: '',
    },
    pathImage: {
      type: String,
      default: 'img/need.png',
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
.needImg {
  object-fit: cover;
  max-width: 280px;
  height: 100%;
}
</style>
